import type { WorkflowCatalog } from '../api/types';

/**
 * Passos no fluxo, gatilho incluído. Vem do catálogo (`limits.maxNodes`); o
 * padrão vale para catálogo antigo em cache. O back recusa acima disso
 * (`too_many_nodes`) e usa o mesmo número como teto de passos seguidos sem
 * espera no motor.
 */
export const DEFAULT_MAX_NODES = 50;

export const maxNodesOf = (catalog: WorkflowCatalog): number =>
  catalog.limits?.maxNodes ?? DEFAULT_MAX_NODES;

/** Quantos passos ainda cabem no fluxo. */
export const nodesRoomLeft = (
  nodeCount: number,
  catalog: WorkflowCatalog,
): number => Math.max(0, maxNodesOf(catalog) - nodeCount);
